<p-dialog
    [(visible)]="visible"
    appendTo="body"
    [modal]="true"
    (onHide)="onHide()"
    [style]="{ 'max-width': '700px', width: '100%' }"
    [header]="header">
    <ng-template pTemplate="content">
        <div class="p-g pt-3">
            <div class="p-g-12">
                <form [formGroup]="shareFileForm" (ngSubmit)="shareFile()">
                    <div class="inputs-group">
                        <div class="inputs-group-row">
                            <div class="inputs-group-row-name">User Type:</div>
                            <div class="inputs-group-row-value">
                                <p-dropdown
                                    [options]="userTypeOptions"
                                    appendTo="body"
                                    (onChange)="filterUsersByRole($event.value)"
                                    placeholder="All User Types"
                                    formControlName="userType"
                                    [showClear]="true">
                                </p-dropdown>
                            </div>
                        </div>
                        <div class="inputs-group-row">
                            <div class="inputs-group-row-name">Name:</div>
                            <div class="inputs-group-row-value">
                                <p-autoComplete
                                    [dropdown]="true"
                                    [suggestions]="userSuggestions"
                                    (completeMethod)="filterUsers($event.query)"
                                    placeholder="Enter username..."
                                    [minLength]="1"
                                    field="fullName"
                                    dataKey="id"
                                    [forceSelection]="true"
                                    (onSelect)="onSelectUser($event.value)"
                                    appendTo="body"
                                    formControlName="user"
                                    [forceSelection]="false">
                                    <ng-template pTemplate="clearicon">
                                        <TimesIcon />
                                    </ng-template>
                                </p-autoComplete>
                            </div>
                        </div>
                        <div class="inputs-group-row">
                            <div class="inputs-group-row-name asterisk-mark">Email Address:</div>
                            <div class="inputs-group-row-value">
                                <input type="email" pInputText formControlName="email" />
                            </div>
                        </div>
                    </div>
                    <div class="inputs-group-row">
                        <form-buttons [disabled]="shareFileForm.invalid" [saving]="sharingFile" [config]="shareFileFormButtonsConfig">
                        </form-buttons>
                    </div>
                </form>
            </div>
        </div>
    </ng-template>
</p-dialog>
